var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNigiri(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6099",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6103"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path6111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g6105",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6109",
    clipPath: "url(#clipPath6113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6115",
    transform: "translate(454.8037,454.9805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -22.992,34.262 -58.636,27.698 -84.797,-27.477 11.239,-3.973 20.562,-9.917 27.952,-17.11 C -41.765,-21.071 -19.902,-4.355 0,0",
    style: {
      fill: "#ffad95",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path6117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6119",
    transform: "translate(454.8037,454.9805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -19.902,-4.355 -41.765,-21.071 -56.845,-44.587 7.783,-7.576 13.424,-16.537 16.905,-26.043 46.802,17.697 96.832,35.325 75.319,60.339 C 26.393,0.158 13.658,2.989 0,0",
    style: {
      fill: "#ffad95",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path6121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6123",
    transform: "translate(397.959,410.3936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.391,7.193 -16.713,13.137 -27.952,17.11 -13.777,4.87 -30.436,6.781 -49.948,4.4 -100.437,-12.25 -333.549,-106.529 -308.137,-230.67 14.428,-70.48 62.76,-91.124 126.241,-83.293 43.985,5.426 111.176,71.008 160.775,114.802 77.546,68.472 64.959,54.579 97.251,79.844 14.928,11.68 22.512,29.037 22.859,46.958 0.161,8.318 -1.237,16.757 -4.185,24.806 C 13.424,-16.537 7.783,-7.576 0,0",
    style: {
      fill: "#ff764e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path6125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6127",
    transform: "translate(298.9375,232.7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -49.599,-43.794 -116.789,-109.376 -160.774,-114.802 -45.544,-5.618 -83.291,3.421 -106.314,35.004 l -0.125,-0.686 c -1.454,-44.248 23.906,-99.078 92.734,-95.539 0,0 59.875,-44.139 147.161,-3.56 0,0 91.615,-2.137 119.027,76.886 0,0 74.301,-6.407 92.335,59.089 33.011,32.578 17.955,83.201 -6.659,104.526 0,0 -3.728,65.496 -57.275,65.885 C 119.764,108.882 112.18,91.524 97.252,79.845 64.96,54.579 77.547,68.473 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path6129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6131",
    transform: "translate(300.7715,234.3613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 75.498,66.618 63.386,53.163 95.418,78.226 47.331,37.034 20.84,131.144 -76.131,119.316 -100.436,-12.25 -333.549,-106.528 -308.137,-230.67 14.428,-70.479 62.76,-91.124 126.242,-83.293 26.327,3.247 60.967,28.048 95.172,56.826",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6135",
    transform: "translate(31.7246,152.2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.454,-44.248 23.906,-99.077 92.734,-95.539 0,0 59.874,-44.139 147.161,-3.56 0,0 91.615,-2.136 119.027,76.886 0,0 74.301,-6.406 92.335,59.089 33.011,32.578 17.955,83.201 -6.659,104.526 0,0 -3.674,64.547 -56.114,65.867",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6139",
    transform: "translate(417.3779,243.8857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.008",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6143",
    transform: "translate(344.4736,176.6475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.008",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6147",
    transform: "translate(253.0908,115.2861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.007",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6151",
    transform: "translate(370.8057,429.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 26.084,53.64 61.239,59.728 83.998,25.813",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6155",
    transform: "translate(398.8926,411.8281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 25.577,38.704 69.477,58.225 91.29,32.861 112.563,8.127 63.88,-9.387 17.537,-26.886",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6157"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6159",
    transform: "translate(178.0371,250.9023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.876,0 25.125,-11.249 25.125,-25.125",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6163",
    transform: "translate(208.332,346.5322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.876,0 25.124,-11.248 25.124,-25.125",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6167",
    transform: "translate(310.3311,353.2822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.877,0 25.125,-11.249 25.125,-25.125",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6171",
    transform: "translate(66.5811,232.5322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.877,0 25.125,-11.249 25.125,-25.125",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6175",
    transform: "translate(267.2305,204.3604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.007",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.613,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6177"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigiri);
export default __webpack_public_path__ + "static/media/nigiri.746e78bd9f64d103e70896b92fe8fcba.svg";
export { ForwardRef as ReactComponent };